import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";

/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

// Phase 3 & 4----------------------------------------------------------------------------------------

// Creer un evenement
export const createEvent = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/event/create`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// Mettre à jour un evenement
export const updateEvent = async (id, payload, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/event/update/${id}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// Delete un evenement
export const deleteEvent = async (id, context) => {
  const response = await axios.delete(
    apiPaths.baseUrl + `/api/event/delete/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// Recuperer tous les evenements de l'annee
export const getEventByYear = async (id_academicYear, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/event/year/${id_academicYear}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// Recuperer tous les evenements de l'annee
export const getEventById = async (id_academicYear, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/event/year/${id_academicYear}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};
